(() => {
  document.querySelectorAll('.mm-nav-dropdown').forEach((wrap) => {
    const btn = wrap.querySelector('.mm-nav-dropdown-trigger');
    const menu = wrap.querySelector('.mm-nav-dropdown-menu');
    if (!btn || !menu) return;

    let closeTimer = null;

    const open = () => {
      if (closeTimer) clearTimeout(closeTimer);
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded','true');
    };

    const close = () => {
      if (closeTimer) clearTimeout(closeTimer);
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded','false');
    };

    const scheduleClose = () => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(close, 180);
    };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      wrap.classList.contains('is-open') ? close() : open();
    });

    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);
    wrap.addEventListener('focusin', open);
    wrap.addEventListener('focusout', (e) => {
      if (!wrap.contains(e.relatedTarget)) scheduleClose();
    });
  });

  document.addEventListener('click', (e) => {
    document.querySelectorAll('.mm-nav-dropdown.is-open').forEach((wrap) => {
      if (wrap.contains(e.target)) return;
      wrap.classList.remove('is-open');
      const btn = wrap.querySelector('.mm-nav-dropdown-trigger');
      if (btn) btn.setAttribute('aria-expanded','false');
    });
  });
})();

/* 212 mobile drawer navigation — delegated/touch-safe */
(() => {
  const getParts = () => {
    const toggle = document.querySelector('.mm-mobile-nav-toggle');
    const menu = document.querySelector('.mm-mobile-menu');
    const overlay = document.querySelector('[data-mobile-nav-overlay]');
    return { toggle, menu, overlay };
  };

  const setTools = (menu, open) => {
    if (!menu) return;
    const toolsToggle = menu.querySelector('.mm-mobile-tools-toggle');
    const toolsPanel = menu.querySelector('.mm-mobile-tools-panel');
    if (!toolsToggle || !toolsPanel) return;
    toolsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toolsPanel.hidden = !open;
  };

  const openMenu = () => {
    const {toggle, menu, overlay} = getParts();
    if (!toggle || !menu || !overlay) return;
    overlay.hidden = false;
    menu.setAttribute('aria-hidden','false');
    requestAnimationFrame(() => {
      overlay.classList.add('is-open');
      menu.classList.add('is-open');
    });
    toggle.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('mm-mobile-nav-lock');
    document.body.classList.add('mm-mobile-nav-lock');
  };

  const closeMenu = () => {
    const {toggle, menu, overlay} = getParts();
    if (!toggle || !menu || !overlay) return;
    overlay.classList.remove('is-open');
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden','true');
    toggle.setAttribute('aria-expanded','false');
    setTools(menu, false);
    document.documentElement.classList.remove('mm-mobile-nav-lock');
    document.body.classList.remove('mm-mobile-nav-lock');
    window.setTimeout(() => {
      if (!overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 250);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.mm-mobile-nav-toggle');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggle.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
      return;
    }

    if (event.target.closest('[data-mobile-nav-close]') ||
        event.target.closest('[data-mobile-nav-overlay]')) {
      event.preventDefault();
      closeMenu();
      return;
    }

    const toolsToggle = event.target.closest('.mm-mobile-tools-toggle');
    if (toolsToggle) {
      event.preventDefault();
      const menu = toolsToggle.closest('.mm-mobile-menu');
      const isOpen = toolsToggle.getAttribute('aria-expanded') === 'true';
      setTools(menu, !isOpen);
      return;
    }

    const mobileLink = event.target.closest('.mm-mobile-menu a');
    if (mobileLink) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const {toggle} = getParts();
    if (toggle && toggle.getAttribute('aria-expanded') === 'true') closeMenu();
  });

  window.addEventListener('resize', () => {
    const {toggle} = getParts();
    if (window.innerWidth > 900 && toggle && toggle.getAttribute('aria-expanded') === 'true') {
      closeMenu();
    }
  });

  /* Reset controls if Shopify reloads the header in the Theme Editor. */
  document.addEventListener('shopify:section:load', () => {
    const {toggle, menu, overlay} = getParts();
    if (toggle) toggle.setAttribute('aria-expanded','false');
    if (menu) {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden','true');
      setTools(menu, false);
    }
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
    }
    document.documentElement.classList.remove('mm-mobile-nav-lock');
    document.body.classList.remove('mm-mobile-nav-lock');
  });
})();
